module.exports = __webpack_public_path__ + "img/bcefe491231f9b5cf0a1976373f81f7a.png";